import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Zap } from 'lucide-react';

import { getBackendUrl } from '../services/origin';
const API = `${getBackendUrl()}/api`;


/**
 * Lands here after Google auth on auth.emergentagent.com.
 * URL shape: /auth/google-callback?flow=login|signup#session_id=XYZ
 *
 * Exchanges the session_id with our backend, then:
 *  - existing admin → set JWT, redirect /admin
 *  - new admin → redirect /signup?email=...&name=...&google_session_id=...
 */
export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // Parse session_id from URL hash (Emergent posts it in #fragment)
    const hashParams = new URLSearchParams((location.hash || '').replace(/^#/, ''));
    const sessionId = hashParams.get('session_id');
    const queryParams = new URLSearchParams(location.search);
    const flow = queryParams.get('flow') || 'login';

    if (!sessionId) {
      toast.error('Sessione Google mancante');
      navigate(flow === 'signup' ? '/signup' : '/admin/login', { replace: true });
      return;
    }

    axios.post(`${API}/auth/google/session`, { session_id: sessionId, flow })
      .then(({ data }) => {
        if (data.exists) {
          localStorage.setItem('admin_token', data.token);
          localStorage.setItem('admin_user', JSON.stringify(data.admin));
          toast.success(`Benvenuto, ${data.admin.name}!`);
          setTimeout(() => { window.location.href = '/admin'; }, 300);
        } else {
          // Pre-fill signup and carry the session_id so backend can re-verify
          const params = new URLSearchParams({
            email: data.email || '',
            name: data.name || '',
            google_session_id: sessionId,
          });
          navigate(`/signup?${params.toString()}`, { replace: true });
        }
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || 'Errore autenticazione Google';
        toast.error(msg);
        navigate(flow === 'signup' ? '/signup' : '/admin/login', { replace: true });
      });
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-[#FFF5F0]" data-testid="google-callback-page">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#D44E20] to-[#F59E0B] flex items-center justify-center mx-auto mb-4 shadow-lg">
          <Zap size={26} className="text-white" />
        </div>
        <Loader2 className="animate-spin text-[#D44E20] mx-auto mb-3" size={28} />
        <p className="text-sm font-semibold text-[#1A1A1A]">Stiamo verificando il tuo account Google...</p>
        <p className="text-xs text-slate-500 mt-1">Un attimo e ti portiamo alla dashboard.</p>
      </div>
    </div>
  );
}
